import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsSuppliers } from "../../../../api/packbo/models/items-suppliers";

type SupplierState = {
    supplier: ItemsSuppliers | null;
};

const initialState: SupplierState = {
    supplier: null
};

export const SupplierStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setSupplier(supplier: ItemsSuppliers | null) {
            patchState(store, { supplier });
        }
    }))
);
